<template>
  <v-container>
    <v-app-bar-nav-icon
      class="hidden-md-and-up"
      color="black"
      @click="drawer = !drawer"
    >
      <v-icon>mdi-dots-vertical</v-icon>
    </v-app-bar-nav-icon>
    <v-navigation-drawer
      floating
      absolute
      app
      disable-resize-watcher
      v-model="drawer"
    >
      <v-list flat class="mt-16">
        <v-list-item-group
          color="primary"
          class="mt-5 ml-8"
          v-model="selectedItem">
          <v-list-item link :to="{ name: 'user_edit', params: { mode: 'base'}}" active-class>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">基本情報</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link :to="{ name: 'user_edit', params: { mode: 'account'}}">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">アカウント設定</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link :to="{ name: 'user_edit', params: { mode: 'pr'}}">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">ユーザーPR設定</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link :to="{ name: 'user_edit', params: { mode: 'link'}}">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">外部リンク</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link :to="{ name: 'user_edit', params: { mode: 'leave'}}">
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">アカウント削除</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item link :to="{ name: 'user', params: { user_code: user.user_code}}">
            <v-list-item-content>
              <v-list-item-title v-if="drawer" class="font-weight-bold">プロフィールに戻る</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-container>
</template>
<script>
export default {
  name: 'UserEdit',
  data() {
    return {
      drawer: true,
      selectedItem: 0,
      user: {
        icon_url: '',
        name: '',
        user_code: '',
        introduction_text: '',
        age: null,
        gender: '',
        prefecture: '',
        address: '',
        favorite_technology: '',
        career: null,
        is_released: false,
        email: '',
      },
      preview: null,
      icon: null,
      loading: true,
      gender: [
        '',
        'man',
        'woman'
      ],
      prefecture: [
        '', '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県',
        '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県',
        '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県',
        '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県',
        '大分県', '宮崎県', '鹿児島県', '沖縄県', 'その他'
      ],
    };
  },
  computed: {
    getUserCode() {
      return this.$store.getters['auth/isUserCode']
    },
    iconPreview() {
      return this.preview;
    },
  },
  methods: {
    getUserInfo() {
      this.$store.dispatch('userinfo/get')
        .then(() => {
          this.user = this.$store.getters['userinfo/getUser']
          this.setIcon()
          this.loading = false;
        });
    },
    setIcon() {
      this.preview = this.user.icon_url;
    },
    isDrawerLayout() {
      if (
        this.$vuetify.breakpoint.name === 'md' ||
        this.$vuetify.breakpoint.name === 'sm' ||
        this.$vuetify.breakpoint.name === 'xs'
      ) {
        return false;
      }
      return true;
    },
  },
  created() {
    this.drawer = this.isDrawerLayout();
    return this.getUserInfo()
  }
}
</script>